import usePWA, { Status } from './usePWA'
import {
  isIOS,
  isInPWA,
  ch,
  isInAndroidApp,
  isApl,
  isFromIOSScreen,
  isInIosApp,
  isEbd,
  params,
} from '@/env'
import { copyText, downloadFile, getAuthStr, getImageUrl } from '@/utils'
import { getInstallConfig, getAntiBlockConfig } from '@/api/config'
import { until } from '@vueuse/core'
// import { useUserInfo } from '@/store'
import showPopup from '@/components/showPopup'
import AddToHomeScreen from '@/components/Installation/AddToHomeScreen.vue'
import { useUserInfo, useSystemInfo } from '@/store'
import type { iUserInfo } from '@/types/index'
import useLoadPreload from './useLoadPreload'

interface iConfig {
  install: 'Enabled' | 'Disabled'
  content: 'Normal' | 'giveEggs'
  presentAmountView: number
  time: 'OnHome' | 'AfterUserDeposit'
  interval: number
  apple: 'Desktop' | 'Appstore'
  appleLink: string
  android: 'Pwa' | 'Apk' | 'pwaApk'
  apkLink: string
  popupNotClose: boolean
  hiddenForcedInstall: boolean
}

const { status, installPWA } = usePWA()

const config = ref<iConfig | null>(null)
const antiBlockUrl = ref<string>('')

// const canShowInstall = computed(
//   () =>
//     ((!isInIosApp && !isInPWA && !isFromIOSScreen && !isInAndroidApp) ||
//       (isInAndroidApp && isApl) ||
//       isEbd) &&
//     !!config.value,
// )

export enum InstallShowType {
  TopBar = '顶部横条',
  BottomPopup = '底部弹窗',
  GuidePopup = '引导弹窗',
  Default = '默认',
}

function canShowInstall(type: InstallShowType) {
  switch (type) {
    case InstallShowType.TopBar:
    case InstallShowType.BottomPopup:
      return (
        (!isInIosApp && !isInPWA && !isFromIOSScreen && !isInAndroidApp)
        || isEbd
      )
    case InstallShowType.GuidePopup:
    case InstallShowType.Default:
    default:
      return (
        (!isInIosApp && !isInPWA && !isFromIOSScreen && !isInAndroidApp)
        || (isInAndroidApp && isApl)
        || isEbd
      )
  }
}

// watch(canShowInstall, (val) => {
//   setTimeout(() => {
//     console.log('canShowInstall', val)
//     console.log('isInPWA', isInPWA)
//     console.log('isFromIOSScreen', isFromIOSScreen)
//     console.log('isInIosApp', isInIosApp)
//     console.log('isApl', isApl)
//     // console.log('isInIframe', isInIframe)
//     console.log('isEbd', isEbd)
//     console.log('config.value', config.value)
//     console.log('!isInIosApp && !isInPWA && !isFromIOSScreen && !isInAndroidApp', !isInIosApp && !isInPWA && !isFromIOSScreen && !isInAndroidApp)
//     console.log('isInAndroidApp && isApl', isInAndroidApp && isApl)
//     // console.log('isInIframe && isEbd', isInIframe && isEbd)
//   }, 3000)
// }, {
//   immediate: true
// })

// watch(canShowInstall, (val) => {
//   setTimeout(() => {
//     console.log('canShowInstall', val)
//     console.log('isInPWA', isInPWA)
//     console.log('isFromIOSScreen', isFromIOSScreen)
//     console.log('isInIosApp', isInIosApp)
//     console.log('isApl', isApl)
//     // console.log('isInIframe', isInIframe)
//     console.log('isEbd', isEbd)
//     console.log('config.value', config.value)
//     console.log('!isInIosApp && !isInPWA && !isFromIOSScreen && !isInAndroidApp', !isInIosApp && !isInPWA && !isFromIOSScreen && !isInAndroidApp)
//     console.log('isInAndroidApp && isApl', isInAndroidApp && isApl)
//     // console.log('isInIframe && isEbd', isInIframe && isEbd)
//   }, 3000)
// }, {
//   immediate: true
// })

const updateInstallConfig = async () => {
  let _ch = ch || 0
  if (useUserInfo().isLoggedin) _ch = useUserInfo().userInfo!.channelNo
  const { code, data } = await getInstallConfig({ ch: _ch }).catch((_) => ({
    code: 0,
    data: null,
  }))
  if (code === 1 && data) {
    config.value = data
  }
}

  const getAntiBlockUrl = async () => {
  const preloadManager = useLoadPreload()
  const blockPreventUrl = preloadManager.getPreloadData()?.blockPreventUrl
  if (blockPreventUrl && useSystemInfo().isInit) {
    antiBlockUrl.value = blockPreventUrl
  } else {
    const { code, data } = await getAntiBlockConfig().catch((_) => ({
      code: 0,
      data: null,
    }))
    antiBlockUrl.value = (code === 1 && data) || ''
  }
  console.log('antiBlockUrl', antiBlockUrl.value)
}

// if (isAndroid && ((!isInPWA && !sealing) || isEbd)) getAntiBlockUrl()


export enum androidInstallType {
  Pwa = 'Pwa',
  Apk = 'Apk',
  PwaApk = 'pwaApk',
}

const _downloadApk = (apkLink: string, fileName: string) => {
  const link = apkLink && getImageUrl(apkLink)
  if (link) {
    const userInfo = (useUserInfo().userInfo || {}) as iUserInfo
    if (params.get('info')) {
      copyText('info=' + params.get('info')!, true)
    } else if (userInfo.token) {
      copyText(getAuthStr(userInfo), true)
    }
    downloadFile(link, fileName)
  }
}

const downloadApk = () => {
  if (!config.value) {
    console.warn('installation config is null')
    return
  }

  const { apkLink } = config.value
  const fileName = apkLink ? apkLink.split('/').pop() : 'apk.apk'
  _downloadApk(apkLink, fileName!)
  // reportRedirect()
}

//尝试通过Schema唤起APK
const tryOpenApk = async () => {
  const { tenantCode } = useSystemInfo().merchantConfig || {}
  const appSchema = `techfunpf://${tenantCode}.open`
  console.log('tryOpenApk', appSchema)

  // 使用 iframe打开intent schema
  const iframe = document.createElement('iframe')
  iframe.style.display = 'none'
  iframe.src = appSchema
  document.body.appendChild(iframe)

  // 延迟检查是否唤起成功
  return new Promise((resolve) => {
    const timer = setTimeout(() => {
      resolve(false) // 超时认为唤起失败
    }, 2000)

    window.addEventListener('visibilitychange', () => {
      // 页面隐藏说明唤起成功
      if (document.hidden) {
        clearTimeout(timer)
        resolve(true)
      }
    })
  })
}

let i = 0
const install = async (check?: (...args: any[]) => Promise<any>) => {
  if (!config.value) {
    console.warn('installation config is null')
    return
  }

  const { apple, appleLink, android, apkLink } = config.value
  if (isIOS) {
    if (apple == 'Desktop') {
      showPopup(AddToHomeScreen, {
        position: 'bottom',
        closeOnClickOverlay: true,
      })
    } else {
      window.open(appleLink)
    }
  } else {
    console.log('安卓安装:', android)
    const fileName = apkLink ? apkLink.split('/').pop() : 'apk.apk'
    if (android == androidInstallType.Apk) {
      // 尝试唤起APK，如果唤起失败，则去下载
      console.log('尝试唤起APK，如果唤起失败，则去下载')
      const res = await tryOpenApk()
      if (!res) {
        console.log('唤起失败，去下载')
        _downloadApk(apkLink, fileName!)
      }
    } else {
      console.log('安装或唤起PWA')
      if (check) {
        const res = await check()
        if (!res) return
      } else {
        await installPWA()
      }

      if (status.value == Status.USER_DISMISSED) return

      if (android == androidInstallType.PwaApk) {
        // 尝试唤起APK，如果唤起失败，则去下载
        const res = await tryOpenApk()
        if (!res) {
          let a = ++i
          await until(status).toMatch((v) => v == Status.CHECK_FAILED && a == i)
          _downloadApk(apkLink, fileName!)
        }
      }
    }
  }
}

const init = async () => {
  if (isInPWA && !isEbd) return
  getAntiBlockUrl()
  await updateInstallConfig()
}

export default function useAPP() {
  return {
    config,
    antiBlockUrl,
    install,
    init,
    canShowInstall,
    downloadApk,
    tryOpenApk,

  }
}
